<template>
  <div class="card-benefit">
    <img
      :src="benefit.image"
      class="card-benefit__image"
      :alt="benefit.title"
    />
    <h5
      :class="
        benefit.isTitleBold ? 'card-benefit__title' : 'card-benefit__title_thin'
      "
    >
      {{ benefit.title }}
    </h5>
    <p class="card-benefit__description" v-html="benefit.description"></p>
  </div>
</template>

<script>
export default {
  name: 'LandingBenefitCard',
  components: {},
  props: {
    benefit: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.card-benefit {
  padding-bottom: rem(20px);

  .card-benefit__image {
    height: 45px;
  }

  .card-benefit__title {
    margin: rem(20px) 0 rem(10px) 0;
    max-width: 90%;
  }

  .card-benefit__title_thin {
    margin: rem(20px) 0 rem(10px) 0;
    max-width: 90%;
    font-weight: 400 !important;
  }

  .card-benefit__description {
    color: $gray-700;
    line-height: 1.5;
    max-width: 90%;
  }
}
</style>
